// extracted by mini-css-extract-plugin
export var buttonContainer = "_5x-1";
export var fontSizeSelect = "_5x-3";
export var formatSelect = "_5x-2";
export var formats = "_5x-4";
export var hidden = "_5x-5";
export var icon = "_5x-6";
export var select = "_5x-0";